import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import { TEXT_INPUT_STYLE_VARIANTS } from "src/components/FormField/constants";
import { OnChangeInput } from "src/@types/form";
import { ReactComponent as SearchIcon } from "src/assets/icons/search.svg";

import { searchTrns } from "./trns";

interface Props {
  onChange: OnChangeInput;
  value: string;
}

export const Search: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="relative sm:max-w-75 lg:max-w-100 w-full">
      <SearchIcon className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400" />

      <input
        className={cn(
          TEXT_INPUT_STYLE_VARIANTS.primary,
          "w-full !pl-11 !pr-4 !p-2 md:!pl-12 md:!pr-5 md:!p-3 text-xl placeholder:text-purple-base"
        )}
        placeholder={t(searchTrns.placeholder)}
        {...props}
      />
    </div>
  );
};
